import React from "react";
import { Play, Loader2 } from "lucide-react";
import { Button } from "@shadcn-in-nx/ui/button";
import { Checkbox } from "@shadcn-in-nx/ui/checkbox";
import { useTranslation } from "react-i18next";
import TestingCaseItem from "./TestingCaseItem";

function TestingCaseList({
    testCases,
    selectedIds,
    onToggleSelect,
    onRunSelected,
    isRunning,
    isLoading,
}) {
    const { t } = useTranslation();

    const allSelected =
        testCases.length > 0 && selectedIds.size === testCases.length;

    const handleSelectAll = () => {
        if (allSelected) {
            testCases.forEach((tc) => {
                if (selectedIds.has(tc.id)) onToggleSelect(tc.id);
            });
        } else {
            testCases.forEach((tc) => {
                if (!selectedIds.has(tc.id)) onToggleSelect(tc.id);
            });
        }
    };

    if (isLoading) {
        return (
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 flex items-center justify-center">
                <Loader2 className="w-6 h-6 animate-spin text-gray-400" />
            </div>
        );
    }

    if (testCases.length === 0) {
        return (
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center text-sm text-gray-500">
                {t("testing.noTests") ||
                    "No tests yet. Tests will be created automatically when you build pages, or you can ask the AI to create them."}
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
                <div className="flex items-center gap-2">
                    <Checkbox
                        checked={allSelected}
                        onCheckedChange={handleSelectAll}
                        disabled={isRunning}
                    />
                    <span className="text-xs text-gray-500">
                        {t("testing.selectAll") || "Select All"}
                    </span>
                </div>
            </div>
            <div className="divide-y divide-gray-100">
                {testCases.map((tc) => (
                    <TestingCaseItem
                        key={tc.id}
                        testCase={tc}
                        isSelected={selectedIds.has(tc.id)}
                        onToggle={() => onToggleSelect(tc.id)}
                        isRunning={isRunning}
                    />
                ))}
            </div>
            {selectedIds.size > 0 && (
                <div className="px-4 py-3 border-t border-gray-100">
                    <Button
                        onClick={onRunSelected}
                        disabled={isRunning}
                        size="sm"
                        variant="outline"
                        className="gap-1"
                    >
                        <Play className="w-3 h-3" />
                        {t("testing.runSelected") || "Run Selected"} ({selectedIds.size})
                    </Button>
                </div>
            )}
        </div>
    );
}

export default TestingCaseList;
